import { FC } from 'react';

import { useTitle } from '../hooks/useTitle';

import Signup from 'src/components/templates/Signup/Signup';

const SignupPage: FC = () => {
  useTitle('GU | 회원가입');
  return <Signup />;
};

export default SignupPage;
